import { useAppRouter } from '@/common/route/useAppRouter';
import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_BONUS } from '@/modules/bonus/router';
import { bonusService } from '@/services/bonus';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useBonusLoginAds() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: null,
        name: '',
        value: '',
        adsBoost: ''
    });

    const validations = {
        adsBoost: { required, format: validateFormat(/^\d+:\d+(,\d+:\d+)*$/) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => bonusService.login.get(route.params.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_BONUS.LOGIN.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => bonusService.login.updateAdsBoost(model.id, model.adsBoost),
            onSuccess: () => router.push({ name: ROUTE_NAME_BONUS.LOGIN.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
